import getI18n from './i18n';
import executeOnload from './onload';

export interface Settings {
  lang: string;
}

export interface AppFactory {
  (root: Element, settings: Settings): () => void;
}

type Callback = () => AppFactory;

const bootstrap = (lang: string, callback: Callback) =>
  getI18n(lang).then(
    () => {
      executeOnload(callback());
    },
    (err: Error) => {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    }
  );

export default bootstrap;
